import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import type React from 'react';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import type { CrossSellSection, ProductCard } from '@repo/supergraph/roundup/base/types';
import { filterEntitiesByState } from '@repo/ui/utils/geo-data';
import { CrossSellCard } from './CrossSellCard';

interface CrossSellModuleProps {
  crossSellSection: CrossSellSection;
  regionCode?: StateAbbreviation;
}

const SECTION_NAME = 'roundup_cross_sell_module';

export const CrossSellModule: React.FC<CrossSellModuleProps> = ({
  crossSellSection,
  regionCode,
}) => {
  if (!crossSellSection) return;
  const { productCards, subtext } = crossSellSection;
  if (!productCards || productCards?.length < 2) {
    return null;
  }

  const geoTargetedCards = regionCode
    ? filterEntitiesByState(productCards, regionCode)
    : productCards;

  return (
    <Box component="section" aria-labelledby="cross-sell-module">
      <Box sx={{ paddingBottom: 3, width: '100%' }}>
        <Typography variant="headline" id="cross-sell-module" component="h2">
          You may also like these
        </Typography>
        <Typography>{subtext}</Typography>
      </Box>
      <Grid container sx={{ gap: 2, flexWrap: { sm: 'unset' } }}>
        {geoTargetedCards.map(
          ({ marketplaceEntity }: Pick<ProductCard, 'marketplaceEntity'>, idx: number) => (
            <CrossSellCard
              key={marketplaceEntity.id}
              elementPosition={idx}
              marketplaceEntity={marketplaceEntity}
              numProductCards={productCards.length}
              sectionName={SECTION_NAME}
            />
          ),
        )}
      </Grid>
    </Box>
  );
};
